import React, { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import { translator } from '../../utils/Translator';
import axios from "axios";
import moment from "moment";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  TextField,
  Button,
  IconButton,
  Box,
  Typography,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  Chip,
  Divider,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import EditIcon from "@material-ui/icons/Edit";
// import InventoryIcon from "@material-ui/icons/Inventory";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import TrendingDownIcon from "@material-ui/icons/TrendingDown";
import StorageIcon from "@material-ui/icons/Storage";

const ProductEditDialog = ({ open, onClose, productData }) => {
  const [stockData, setStockData] = useState([]);
  const [quantities, setQuantities] = useState({
    กล่อง: 0,
    ลัง: 0,
    แผง: 0,
    ชิ้น: 0
  });
  const { translate } = useSelector(({ i18n }) => i18n);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStockData = async () => {

      const token = localStorage.getItem("x-access-token");
      if (!productData) return;

      setLoading(true);
      setError(null);

      try {
        const param = {
          company: productData.company || "81",
          customerCode: productData.customerCode,
          productCode: productData.รหัสสินค้า || productData.productCode,
          salesmanCode: productData.salesmanCode || "PKTF2",
        };

        const url = `${process.env.REACT_APP_API_URL}CustomerAccount/getEditStockCardForUI`;


        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
          params: param,
        });


        const mappedData = response.data.data.map((item, index) => {
          
          return {
            date: item.DocCreateTime,
            stock: item.DocType === "Stock" ? item.ProductQuan : 0,
            sellIn: item.DocType === "SellIn" ? item.ProductQuan : 0,
            sellOut: item.DocType === "SaleOut" ? item.ProductQuan : 0,
          };
        });

        setStockData(mappedData);
      } catch (err) {
        console.error("Error fetching stock data:", err);
        setError(
          translator(
            translate.ISA_FailedToFetchStockData,
            "Failed to fetch stock data. Please try again later."
          )
        );
      } finally {
        setLoading(false);
      }
    };

    fetchStockData();
  }, [productData]);

  const handleQuantityChange = (unit, newValue) => {
    const value = Math.max(0, parseInt(newValue) || 0);
    setQuantities(prev => ({
      ...prev,
      [unit]: value
    }));
  };

  const incrementQuantity = (unit) => {
    setQuantities(prev => ({
      ...prev,
      [unit]: prev[unit] + 1
    }));
  };

  const decrementQuantity = (unit) => {
    setQuantities(prev => ({
      ...prev,
      [unit]: Math.max(0, prev[unit] - 1)
    }));
  };

  const handleSubmit = () => {
    // รวมทุกหน่วยที่มีจำนวนมากกว่า 0
    const selectedUnits = [];
    
    for (const [unit, value] of Object.entries(quantities)) {
      if (value > 0) {
        selectedUnits.push(`${value} ${getUnitLabel(unit)}`);
      }
    }


    // สร้างข้อความแสดงจำนวน เช่น "1 ลัง 2 แผง"
    const displayQuantity = selectedUnits.length > 0 
      ? selectedUnits.join(' ') 
      : "0";

    // ส่งข้อมูลกลับไปพร้อมจำนวนที่เลือก
    if (productData.onSave) {
      productData.onSave({
        ...productData,
        สั่งใหม่: displayQuantity, // แสดงเป็น "1 ลัง 2 แผง"
        quantities: quantities, // เก็บรายละเอียดแต่ละหน่วย
      });
    }

    onClose();
  };

  const getUnitMultiplier = (unit) => {
    const multipliers = { 'กล่อง': 144, 'ลัง': 24, 'แผง': 12, 'ชิ้น': 1 };
    return multipliers[unit] || 1;
  };

  const getUnitLabel = (unit) => {
    if (unit === "กล่อง") {
      return translator(translate.ISA_UnitBox, "กล่อง");
    }
    if (unit === "ลัง") {
      return translator(translate.ISA_UnitCrate, "ลัง");
    }
    if (unit === "แผง") {
      return translator(translate.ISA_UnitTray, "แผง");
    }
    if (unit === "ชิ้น") {
      return translator(translate.ISA_UnitPiece, "ชิ้น");
    }
    return unit;
  };

  if (!productData) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: 16,
          boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
          minHeight: "80vh",
          overflow: "hidden",
        },
      }}
    >
      {/* Enhanced Header */}
      <DialogTitle
        style={{
          background: "linear-gradient(135deg, #f97316 0%, #ea580c 100%)",
          color: "white",
          padding: "24px 32px",
          position: "relative",
        }}
      >
        <Typography
          style={{
            fontSize: "1.25rem",
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            gap: 12,
          }}
        >
          <EditIcon />
          {translator(
            translate.ISA_StockCount_ProductInfoEditItem,
            "ข้อมูลสินค้า (แก้ไขรายการที่ 1)"
          )}
        </Typography>
        <Typography
          style={{
            fontSize: "0.875rem",
            opacity: 0.9,
            marginTop: 4,
          }}
        >
          {translator(
            translate.ISA_StockCount_ShowSelectedPriority,
            "แสดงตามสำคัญที่เลือก"
          )}
        </Typography>
        <Typography
          onClick={onClose}
          style={{
            position: "absolute",
            right: 20,
            top: "50%",
            transform: "translateY(-50%)",
            cursor: "pointer",
            fontSize: "1.5rem",
            fontWeight: "bold",
            width: 36,
            height: 36,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            backgroundColor: "rgba(255,255,255,0.2)",
            transition: "all 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "rgba(255,255,255,0.3)";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "rgba(255,255,255,0.2)";
          }}
        >
          ×
        </Typography>
      </DialogTitle>
      
      <DialogContent
        style={{
          backgroundColor: "#f8fafc",
          padding: "32px",
        }}
      >
        {/* Product Info Card */}
        <Card
          style={{
            marginBottom: 24,
            borderRadius: 16,
            boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
            border: "1px solid #e2e8f0",
          }}
        >
          <CardContent style={{ padding: "24px" }}>
            <Box display="flex" alignItems="center" mb={2}>
              {/* <InventoryIcon style={{ color: "#f97316", marginRight: 12 }} /> */}
              <Typography
                style={{
                  fontSize: "1.125rem",
                  fontWeight: 600,
                  color: "#1e293b",
                }}
              >
                {translator(translate.ISA_ProductInfo, "ข้อมูลสินค้า")}
              </Typography>
            </Box>
            
            <Box display="flex" alignItems="center" gap={3}>
              <Avatar
                src="/api/placeholder/80/80"
                alt="Product"
                style={{
                  width: 80,
                  height: 80,
                  border: "3px solid #e2e8f0",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  borderRadius: 12,
                }}
              >
                {/* <InventoryIcon style={{ fontSize: 32, color: "#6b7280" }} /> */}
              </Avatar>
              
              <Box flex={1}>
                <Typography
                  style={{
                    fontSize: "1.25rem",
                    fontWeight: 600,
                    color: "#1e293b",
                    marginBottom: 8,
                  }}
                >
                  {productData.ชื่อสินค้า || productData.productName || translator(translate.ISA_ProductNameNotSpecified, "ไม่ระบุชื่อสินค้า")}
                </Typography>
                <Chip
                  label={productData.รหัสสินค้า || productData.productCode || translator(translate.ISA_NoData, "N/A")}
                  size="small"
                  style={{
                    backgroundColor: "#fed7aa",
                    color: "#c2410c",
                    fontWeight: 500,
                    fontFamily: "monospace",
                  }}
                />
              </Box>
            </Box>
          </CardContent>
        </Card>

        {/* Stock Data Card */}
        <Card
          style={{
            marginBottom: 24,
            borderRadius: 16,
            boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
            border: "1px solid #e2e8f0",
          }}
        >
          <CardContent style={{ padding: "24px" }}>
            <Box display="flex" alignItems="center" mb={3}>
              <StorageIcon style={{ color: "#f97316", marginRight: 12 }} />
              <Typography
                style={{
                  fontSize: "1.125rem",
                  fontWeight: 600,
                  color: "#1e293b",
                }}
              >
                {translator(translate.ISA_StockHistory, "ประวัติสต๊อก")}
              </Typography>
            </Box>

            {loading ? (
              <Typography>
                {translator(
                  translate.ISA_LoadingStockData,
                  "Loading stock data..."
                )}
              </Typography>
            ) : error ? (
              <Typography color="error">{error}</Typography>
            ) : (
              <TableContainer
                style={{
                  borderRadius: 12,
                  border: "1px solid #e2e8f0",
                  overflow: "hidden",
                }}
              >
                <Table>
                  <TableHead>
                    <TableRow style={{ backgroundColor: "#f8fafc" }}>
                      <TableCell
                        style={{
                          fontWeight: 600,
                          color: "#374151",
                          borderBottom: "1px solid #e5e7eb",
                        }}
                      >
                        {translator(translate.ISA_Date, "วันที่")}
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{
                          fontWeight: 600,
                          color: "#374151",
                          borderBottom: "1px solid #e5e7eb",
                        }}
                      >
                        {translator(translate.ISA_Stock_2, "Stock")}
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{
                          fontWeight: 600,
                          color: "#374151",
                          borderBottom: "1px solid #e5e7eb",
                        }}
                      >
                        {translator(translate.ISA_SellIn, "Sell In")}
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{
                          fontWeight: 600,
                          color: "#374151",
                          borderBottom: "1px solid #e5e7eb",
                        }}
                      >
                        {translator(translate.ISA_SellOut, "Sell Out")}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {stockData.map((row, index) => (
                      <TableRow
                        key={index}
                        style={{
                          backgroundColor: index % 2 === 0 ? "#ffffff" : "#f9fafb",
                        }}
                      >
                        <TableCell style={{ borderBottom: "1px solid #f3f4f6" }}>
                          <Typography style={{ fontWeight: 500 }}>
                            {row.date 
                              ? moment(row.date, "YYYYMMDDHHmmss").format("DD MMM YYYY") 
                              : "N/A"}
                          </Typography>
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ borderBottom: "1px solid #f3f4f6" }}
                        >
                          <Typography style={{ fontWeight: 500 }}>
                            {row.stock.toFixed(2)}
                          </Typography>
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ borderBottom: "1px solid #f3f4f6" }}
                        >
                          <Typography style={{ fontWeight: 500, color: "#059669" }}>
                            {row.sellIn.toFixed(2)}
                          </Typography>
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ borderBottom: "1px solid #f3f4f6" }}
                        >
                          <Typography style={{ fontWeight: 500, color: "#dc2626" }}>
                            {row.sellOut.toFixed(2)}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </CardContent>
        </Card>

        {/* Quantity Selection Card */}
        <Card
          style={{
            borderRadius: 16,
            boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
            border: "1px solid #e2e8f0",
          }}
        >
          <CardContent style={{ padding: "32px" }}>
            <Typography
              style={{
                fontSize: "1.125rem",
                fontWeight: 600,
                color: "#1e293b",
                marginBottom: 24,
                textAlign: "center",
              }}
            >
              {translator(
                translate.ISA_SelectProductQuantity,
                "เลือกจำนวนสินค้า"
              )}
            </Typography>

            <Grid container spacing={4}>
              {Object.entries(quantities).map(([unit, value]) => (
                <Grid item xs={12} sm={6} md={3} key={unit}>
                  <Box
                    style={{
                      background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
                      borderRadius: 16,
                      padding: "20px",
                      textAlign: "center",
                      border: "1px solid #e2e8f0",
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: "1rem",
                        fontWeight: 600,
                        color: "#374151",
                        marginBottom: 8,
                      }}
                    >
                      {getUnitLabel(unit)}
                    </Typography>
                    <Chip
                      label={`${getUnitMultiplier(unit)} ${translator(translate.ISA_UnitPiece, "ชิ้น")}`}
                      size="small"
                      style={{
                        backgroundColor: "#fed7aa",
                        color: "#c2410c",
                        fontWeight: 500,
                        marginBottom: 16,
                      }}
                    />
                    
                    <Box display="flex" alignItems="center" justifyContent="center" gap={2}>
                      <IconButton
                        size="small"
                        onClick={() => decrementQuantity(unit)}
                        style={{
                          backgroundColor: "#fee2e2",
                          color: "#dc2626",
                          width: 36,
                          height: 36,
                          "&:hover": {
                            backgroundColor: "#fecaca",
                          },
                        }}
                      >
                        <RemoveIcon fontSize="small" />
                      </IconButton>
                      
                      <TextField
                        size="small"
                        value={value}
                        onChange={(e) => handleQuantityChange(unit, e.target.value)}
                        variant="outlined"
                        style={{ width: 80 }}
                        InputProps={{
                          style: {
                            textAlign: "center",
                            borderRadius: 8,
                            backgroundColor: "white",
                            fontWeight: 600,
                          },
                        }}
                        inputProps={{
                          style: { textAlign: "center" },
                        }}
                      />
                      
                      <IconButton
                        size="small"
                        onClick={() => incrementQuantity(unit)}
                        style={{
                          backgroundColor: "#dcfce7",
                          color: "#059669",
                          width: 36,
                          height: 36,
                          "&:hover": {
                            backgroundColor: "#bbf7d0",
                          },
                        }}
                      >
                        <AddIcon fontSize="small" />
                      </IconButton>
                    </Box>
                    
                    <Typography
                      style={{
                        fontSize: "0.875rem",
                        color: "#6b7280",
                        marginTop: 12,
                        fontWeight: 500,
                      }}
                    >
                      {translator(translate.ISA_Total, "รวม")}: {value * getUnitMultiplier(unit)} {translator(translate.ISA_UnitPiece, "ชิ้น")}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>

            <Divider style={{ margin: "32px 0" }} />

            {/* Summary */}
            <Box
              style={{
                background: "linear-gradient(135deg, #ffedd5 0%, #fed7aa 100%)",
                borderRadius: 12,
                padding: "20px",
                textAlign: "center",
              }}
            >
              <Typography
                style={{
                  fontSize: "1.125rem",
                  fontWeight: 600,
                  color: "#c2410c",
                  marginBottom: 8,
                }}
              >
                {translator(translate.ISA_SelectedQuantity, "จำนวนที่เลือก")}
              </Typography>
              <Typography
                style={{
                  fontSize: "2rem",
                  fontWeight: 700,
                  color: "#c2410c",
                }}
              >
                {(() => {
                  // รวมทุกหน่วยที่มีจำนวนมากกว่า 0
                  const selectedUnits = [];
                  for (const [unit, value] of Object.entries(quantities)) {
                    if (value > 0) {
                      selectedUnits.push(`${value} ${getUnitLabel(unit)}`);
                    }
                  }
                  return selectedUnits.length > 0 
                    ? selectedUnits.join(' ') 
                    : translator(translate.ISA_NotSelectedYet, "ยังไม่ได้เลือก");
                })()}
              </Typography>
              <Typography
                style={{
                  fontSize: "0.875rem",
                  color: "#92400e",
                  marginTop: 8,
                }}
              >
                ({Object.entries(quantities).reduce(
                  (total, [unit, value]) => total + value * getUnitMultiplier(unit),
                  0
                ).toLocaleString()} {translator(translate.ISA_UnitPiece, "ชิ้น")})
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </DialogContent>

      {/* Enhanced Action Buttons */}
      <Box
        style={{
          background: "linear-gradient(to top, #f8fafc, #ffffff)",
          padding: "24px 32px",
          borderTop: "1px solid #e5e7eb",
          display: "flex",
          justifyContent: "center",
          gap: 16,
        }}
      >
        <Button
          variant="outlined"
          onClick={onClose}
          size="large"
          style={{
            borderColor: "#e5e7eb",
            color: "#6b7280",
            borderRadius: 12,
            textTransform: "none",
            padding: "12px 32px",
            fontWeight: 500,
            fontSize: "1rem",
          }}
        >
          {translator(translate.ISA_Cancel1, "ยกเลิก")}
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          size="large"
          style={{
            background: "linear-gradient(135deg, #f97316 0%, #ea580c 100%)",
            color: "white",
            borderRadius: 12,
            textTransform: "none",
            padding: "12px 32px",
            fontWeight: 600,
            fontSize: "1rem",
            boxShadow: "0 4px 12px rgba(249, 115, 22, 0.3)",
          }}
        >
          {translator(translate.ISA_Confirm, "ยืนยัน")}
        </Button>
      </Box>
    </Dialog>
  );
};

export default ProductEditDialog;